/**
 * @generated SignedSource<<376adf9866c2c2964921d4dc1cd16c0a>>
 * @lightSyntaxTransform
 * @nogrep
 */
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
import { ConcreteRequest } from 'relay-runtime';

export type LoanApprovalStatus = 'APPROVED' | 'NONE' | 'REJECTED' | 'UNDECIDED' | '%future added value';
export type UnderwriteRequest = {
  approvalStatusOverride?: LoanApprovalStatus | null;
  creditApplicationId: string;
  creditLimitOverrideMicro?: number | null;
};
export type NavigationProviderUnderwriteMutation$variables = {
  q: UnderwriteRequest;
};
export type NavigationProviderUnderwriteMutation$data = {
  readonly underwriteApplication: {
    readonly data: {
      readonly creditApplication: {
        readonly id: string;
      };
    } | null;
  };
};
export type NavigationProviderUnderwriteMutation = {
  response: NavigationProviderUnderwriteMutation$data;
  variables: NavigationProviderUnderwriteMutation$variables;
};

const node: ConcreteRequest = (function () {
  var v0 = [
      {
        defaultValue: null,
        kind: 'LocalArgument',
        name: 'q',
      },
    ],
    v1 = [
      {
        alias: null,
        args: [
          {
            kind: 'Variable',
            name: 'q',
            variableName: 'q',
          },
        ],
        concreteType: 'UnderwriteApplicationResolverResponseValidation',
        kind: 'LinkedField',
        name: 'underwriteApplication',
        plural: false,
        selections: [
          {
            alias: null,
            args: null,
            concreteType: 'UnderwriteResponse',
            kind: 'LinkedField',
            name: 'data',
            plural: false,
            selections: [
              {
                alias: null,
                args: null,
                concreteType: 'CreditApplication',
                kind: 'LinkedField',
                name: 'creditApplication',
                plural: false,
                selections: [
                  {
                    alias: null,
                    args: null,
                    kind: 'ScalarField',
                    name: 'id',
                    storageKey: null,
                  },
                ],
                storageKey: null,
              },
            ],
            storageKey: null,
          },
        ],
        storageKey: null,
      },
    ];
  return {
    fragment: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Fragment',
      metadata: null,
      name: 'NavigationProviderUnderwriteMutation',
      selections: v1 /*: any*/,
      type: 'Mutation',
      abstractKey: null,
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Operation',
      name: 'NavigationProviderUnderwriteMutation',
      selections: v1 /*: any*/,
    },
    params: {
      cacheID: '512d3178bb79e9cf5f2c4a33d31e9561',
      id: null,
      metadata: {},
      name: 'NavigationProviderUnderwriteMutation',
      operationKind: 'mutation',
      text: 'mutation NavigationProviderUnderwriteMutation(\n  $q: UnderwriteRequest!\n) {\n  underwriteApplication(q: $q) {\n    data {\n      creditApplication {\n        id\n      }\n    }\n  }\n}\n',
    },
  };
})();

(node as any).hash = '39f8f84f1ebc1734b3c06d6d93f05b5e';

export default node;
